/**
 * @file
 * Adds decrease and increase buttons to cart quantity inputs.
 */
(function (Drupal, once) {
  'use strict';
  Drupal.behaviors.adocsCartQuantityStepper = {
    attach(context) {
      once(
        'adocs-cart-quantity-stepper',
        '.view-commerce-cart-form .quantity-edit-input',
        context,
      ).forEach((input) => {
        const wrapper = document.createElement('div');
        const decreaseButton = document.createElement('button');
        const increaseButton = document.createElement('button');
        wrapper.className = 'quantity-stepper';
        decreaseButton.type = 'button';
        decreaseButton.className =
          'quantity-stepper__button quantity-stepper__button--decrease';
        decreaseButton.textContent = '−';
        decreaseButton.setAttribute('aria-label', Drupal.t('Decrease quantity'));
        increaseButton.type = 'button';
        increaseButton.className =
          'quantity-stepper__button quantity-stepper__button--increase';
        increaseButton.textContent = '+';
        increaseButton.setAttribute('aria-label', Drupal.t('Increase quantity'));
        input.parentNode.insertBefore(wrapper, input);
        wrapper.append(decreaseButton, input, increaseButton);
        const changeQuantity = (direction) => {
          const step = Number.parseFloat(input.step) || 1;
          const currentValue = Number.parseFloat(input.value) || 0;
          const minimum =
            input.min === '' ? Number.NEGATIVE_INFINITY : Number(input.min);
          const maximum =
            input.max === '' ? Number.POSITIVE_INFINITY : Number(input.max);
          const newValue = Math.min(
            maximum,
            Math.max(minimum, currentValue + direction * step),
          );
          if (newValue === currentValue) {
            return;
          }
          input.value = String(newValue);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        decreaseButton.addEventListener('click', () => {
          changeQuantity(-1);
        });
        increaseButton.addEventListener('click', () => {
          changeQuantity(1);
        });
      });
    },
  };
})(Drupal, once);